import { GetServerSidePropsContext } from "next";
import api from "./api";
import { Section } from "./section-model";

export type { Section };

export default function loadCategories(
  companySlug: string,
  context?: GetServerSidePropsContext,
  appId?: string
) {
  return api<Section[] | undefined>({
    path: `/helpcenter-public/categories/${companySlug}`,
    context,
    appId,
  }).then((categories) => categories?.sort((a, b) => a.order - b.order));
}
